module.exports = __webpack_public_path__ + "img/galaxy-shooter-1.25cbd4c0.png";